import { stepOtherTugoLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data) {
  return [];
}

// Generic function to map any type of expense
function mapExpensesByType(data, itemsKey, expenseLookupKey, condition = true) {
  if (!condition || !data[itemsKey] || data[itemsKey].length < 1) {
    return [];
  }

  // Get claim code from associatedClaimCodes
  const lookup = expenseLookup[expenseLookupKey];
  const claimCode = lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
    ? lookup.associatedClaimCodes[0]
    : (lookup.claimCode || null);

  if (!claimCode) {
    return [];
  }
  const expenses = [];

  data[itemsKey].forEach((item) => {
    const expense = mapExpenseItem(item, data, claimCode);
    if (!!expense) {
      expenses.push(expense);
    }
  });

  return expenses;
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  const expenseConfigs = [
    {
      items: 'repatriationBenefitItems',
      lookup: 'repatriationBenefit',
      condition: expensesSelected.includes('Repatriation Benefit (Return of Remains)'),
    },
    {
      items: 'repatriationItems',
      lookup: 'repatriation',
      condition: expensesSelected.includes('Repatriation (Burial at place of death)'),
    },
    {
      items: 'returnHomeBenefitItems',
      lookup: 'returnHomeBenefit',
      condition: expensesSelected.includes('Return Home Benefit'),
    },
    {
      items: 'deathRemainsItems',
      lookup: 'deathRemains',
      condition: expensesSelected.includes('Return of remains to home country'),
    },
    {
      items: 'deathBurialItems',
      lookup: 'deathBurial',
      condition: expensesSelected.includes('Burial or Cremation at Place of Death'),
    },
    {
      items: 'deathTransportItems',
      lookup: 'deathTransport',
      condition: expensesSelected.includes('Transportation of Family Member to Identify Remains when required'),
    },
    {
      items: 'airFlightCommonCarrierAccidentItems',
      lookup: 'airFlightCommonCarrierAccident',
      condition: expensesSelected.includes('Air Flight/Common Carrier Accident Benefits'),
    },
    {
      items: 'accident24HourItems',
      lookup: 'accident24Hour',
      condition: expensesSelected.includes('24 Hour Accident Benefits'),
    },
  ];

  // Map all expenses using the generic function
  const allExpenses = expenseConfigs.flatMap((config) =>
    mapExpensesByType(data, config.items, config.lookup, config.condition)
  );

  return [...allExpenses];
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor;
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  if (expensesSelected.length < 1 || claimTypes === undefined) {
    return list;
  }

  // Get all other expenses
  const otherExpenses = mapToExpenses(data);

  // Create mapping of claim codes to expense types
  const claimCodeMapping = {
    [expenseLookup.repatriationBenefit.claimCode]: 'Repatriation Benefit (Return of Remains)',
    [expenseLookup.repatriation.claimCode]: 'Repatriation (Burial at place of death)',
    [expenseLookup.returnHomeBenefit.claimCode]: 'Return Home Benefit',
    [expenseLookup.deathRemains.claimCode]: 'Return of remains to home country',
    [expenseLookup.deathBurial.claimCode]: 'Burial or Cremation at Place of Death',
    [expenseLookup.deathTransport.claimCode]: 'Transportation of Family Member to Identify Remains when required',
    [expenseLookup.airFlightCommonCarrierAccident.claimCode]: 'Air Flight/Common Carrier Accident Benefits',
    [expenseLookup.accident24Hour.claimCode]: '24 Hour Accident Benefits',
  };

  // Map each claim type to its corresponding expenses
  claimTypes.forEach((item) => {
    const expenseType = claimCodeMapping[item.claimCode];
    if (expenseType && expensesSelected.includes(expenseType)) {
      const benefit = mapClaimExpensesLevelItem(
        item,
        expenseType,
        otherExpenses.filter((expense) => expense.claimTypeCode === item.claimCode)
      );
      list.push(benefit);
    }
  });

  return list;
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepOtherDataTugoMapper.js